import MedicationCard from "./MedicationCard";

export default MedicationCard;